export default __webpack_public_path__ + "static/media/rota_baron_full.97b7e16f.png";